import PropTypes from "prop-types";
import { htmlSanitize } from "app/utils/sanitize";
import { useTemplateRender, useTemplateRenderToString } from "app/utils/hooks/useTemplateRender";
import "./paragraphs.scss";

const identity = html => html;

const Paragraphs = ({
	paragraphs = [],
	enableHTMLFormatting = false,
	transformHtml = identity,
}) => {
	const templateRender = useTemplateRender();
	const templateRenderToString = useTemplateRenderToString();

	if (Array.isArray(paragraphs)) {
		const paragraphNodes = paragraphs.map((paragraph, index) => {
			if (enableHTMLFormatting === true) {
				return (
					<article
						className="paragraphs__item"
						key={index}
						dangerouslySetInnerHTML={{
							__html: transformHtml(htmlSanitize(templateRenderToString(paragraph))),
						}}
					/>
				);
			}
			return (
				<article className="paragraphs__item" key={index}>
					{templateRender(paragraph)}
				</article>
			);
		});
		return <section className="paragraphs">{paragraphNodes}</section>;
	}
	return (
		<section
			className="paragraphs"
			dangerouslySetInnerHTML={{
				__html: transformHtml(htmlSanitize(templateRenderToString(paragraphs))),
			}}
		/>
	);
};

Paragraphs.propTypes = {
	paragraphs: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
	enableHTMLFormatting: PropTypes.bool,
	transformHtml: PropTypes.func,
};

export default Paragraphs;
